export default "__VITE_ASSET__DjDwV4mt__"